import React, { useState, useEffect } from 'react';
import { SEO } from '../components/SEO';
import { Link } from 'react-router-dom';
import { FaYoutube, FaPlay, FaArrowRight, FaCalendarAlt, FaCheckCircle } from 'react-icons/fa';
import ScrollToTopLink from '../components/ScrollToTopLink';

const AcademiaOpus = () => {
  const [activeSection, setActiveSection] = useState('overview');

  // Reset scroll position when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Video data for each module
  const videoModules = [
    {
      id: 'presupuesto',
      title: 'M1 PRESUPUESTO PROGRAMABLE',
      playlistUrl: 'https://www.youtube.com/playlist?list=PL-hscUQXMp_lFaKz-xnduyiaBJ8qODQUR',
      videos: [
        { 
          id: 'fWuQXuviqAw', 
          title: 'Presupuesto OPUS | Conoce sus funciones | ECOSOFT', 
          duration: '10:28',
          date: '10/03/2023'
        },
        { 
          id: '6ohyJNfeKTs', 
          title: 'Presupuesto OPUS | Catálogos y Generador | ECOSOFT', 
          duration: '09:17',
          date: '17/03/2023' 
        },
        { 
          id: 'VNP2gzgHQlk', 
          title: 'Presupuesto OPUS | Configuraciones | ECOSOFT', 
          duration: '08:36',
          date: '24/03/2023' 
        }
      ]
    },
    {
      id: 'planeacion',
      title: 'M2 PLANEACIÓN Y CONTROL INTEGRAL',
      playlistUrl: 'https://www.youtube.com/playlist?list=PL-hscUQXMp_lhRGD6dpO7--8IjJpK-MtD',
      videos: [
        { 
          id: '1hrwkt2-6Po', 
          title: 'Planeación y Control | Programación | ECOSOFT', 
          duration: '06:13',
          date: '07/04/2023' 
        },
        { 
          id: '0_5Ui9Lx7f8', 
          title: 'Planeación y Control | Reportes y Actividades | ECOSOFT', 
          duration: '07:45',
          date: '14/04/2023' 
        },
        { 
          id: 'gVKcQbNt35Y', 
          title: 'Planeación y Control | Seguimiento | ECOSOFT', 
          duration: '10:22',
          date: '21/04/2023' 
        }
      ]
    },
    {
      id: 'compras',
      title: 'M3 ADMINISTRACIÓN DE COMPRAS',
      playlistUrl: 'https://www.youtube.com/playlist?list=PL-hscUQXMp_lrvgwK_IbW2AekFB0xcxuQ',
      videos: [
        { 
          id: '0_5Ui9Lx7f8', 
          title: 'Administración de Compras | Estimaciones | ECOSOFT', 
          duration: '11:10',
          date: '05/05/2023' 
        },
        { 
          id: 'v9ow6wN7vs0', 
          title: 'Administración de Compras | Requisiciones | ECOSOFT', 
          duration: '09:45',
          date: '12/05/2023' 
        },
        { 
          id: 'rxz1dhP5V3M', 
          title: 'Administración de Compras | Órdenes de Compra | ECOSOFT', 
          duration: '08:25',
          date: '19/05/2023' 
        }
      ]
    },
    {
      id: 'dependencias',
      title: 'M4 DEPENDENCIAS',
      playlistUrl: 'https://www.youtube.com/playlist?list=PL-hscUQXMp_mfxTX0dh4By0O9XnOV3Lfa',
      videos: [
        { 
          id: 'nxQHDGE2Z50', 
          title: 'Dependencias OPUS | Licitaciones | ECOSOFT', 
          duration: '11:37',
          date: '02/06/2023' 
        },
        { 
          id: 'XED1IDloJNo', 
          title: 'Dependencias OPUS | Base de Concurso | ECOSOFT', 
          duration: '12:12',
          date: '09/06/2023' 
        },
        { 
          id: 'Kj4t2A0H2gQ', 
          title: 'Dependencias OPUS | Reportes | ECOSOFT', 
          duration: '10:18',
          date: '16/06/2023' 
        }
      ]
    },
    {
      id: 'bim',
      title: 'M5 CUANTIFICACIÓN BIM',
      playlistUrl: 'https://www.youtube.com/playlist?list=PL-hscUQXMp_mqgLeHO7J4fh1LWvHQ_UvE',
      videos: [
        { 
          id: 'Ok6Ip1fCT54', 
          title: 'Cuantificación BIM | Integración con Revit | ECOSOFT', 
          duration: '13:15',
          date: '23/06/2023' 
        },
        { 
          id: '9sK-C9ti6ng', 
          title: 'Cuantificación BIM | Modelos 3D | ECOSOFT', 
          duration: '11:40',
          date: '30/06/2023' 
        },
        { 
          id: '4sBbv9xcDXs', 
          title: 'Cuantificación BIM | Automatización | ECOSOFT', 
          duration: '09:53',
          date: '07/07/2023' 
        }
      ]
    },
    {
      id: 'erp',
      title: 'OPUS ERP / ODOO',
      playlistUrl: 'https://www.youtube.com/playlist?list=PL-hscUQXMp_l29K95gm81qSmmBru9pNSV',
      videos: [
        { 
          id: 'U7ivV6xup3c', 
          title: 'OPUS ERP | Gestión Integral | ECOSOFT', 
          duration: '12:23',
          date: '14/07/2023' 
        },
        { 
          id: '5ifovAskGz8', 
          title: 'OPUS ERP | Funcionalidades | ECOSOFT', 
          duration: '10:47',
          date: '21/07/2023' 
        },
        { 
          id: 'ESQdKWsgfkI', 
          title: 'OPUS ERP | Módulos | ECOSOFT', 
          duration: '09:35',
          date: '28/07/2023' 
        }
      ]
    },
    {
      id: 'tecnicos',
      title: 'OPUS ASPECTOS TÉCNICOS',
      playlistUrl: 'https://www.youtube.com/playlist?list=PL-hscUQXMp_l29K95gm81qSmmBru9pNSV',
      videos: [
        { 
          id: 'knVD8nptXEo', 
          title: 'OPUS | Instalación y Configuración | ECOSOFT', 
          duration: '12:23',
          date: '04/08/2023' 
        },
        { 
          id: 'JW1PvcwLmyg', 
          title: 'OPUS | Administrador de Licencias | ECOSOFT', 
          duration: '08:47',
          date: '11/08/2023' 
        },
        { 
          id: 'iKtwHb9x2R8', 
          title: 'OPUS | Respaldo y Recuperación | ECOSOFT', 
          duration: '07:35',
          date: '18/08/2023' 
        }
      ]
    }
  ];

  // Upcoming webinars
  const upcomingWebinars = [
    {
      title: "TOP DE NOVEDADES OPUS25 (sesión 1)",
      date: "Martes, 11:00 AM",
      time: "11:00 AM (CDMX)",
      presenter: "Arq. Sara Garcia",
      registrationLink: "https://www.facebook.com/ECOSOFTOPUS/events"
    },
    {
      title: "TOP DE NOVEDADES OPUS25 (sesión 2)",
      date: "Martes, 11:00 AM",
      time: "11:00 AM (CDMX)",
      presenter: "Arq. Sara Garcia",
      registrationLink: "https://www.facebook.com/ECOSOFTOPUS/events"
    },
    {
      title: "TOP DE NOVEDADES OPUS25 (sesión 3)",
      date: "Martes, 11:00 AM",
      time: "11:00 AM (CDMX)",
      presenter: "Arq. Sara Garcia",
      registrationLink: "https://www.facebook.com/ECOSOFTOPUS/events"
    }
  ];

  // Handle scroll for section highlighting
  useEffect(() => {
    const handleScroll = () => {
      // Set active section based on scroll position
      const sections = ['overview', 'presupuesto', 'planeacion', 'compras', 'dependencias', 'bim', 'erp', 'tecnicos', 'upcoming'];
      let activeFound = false;
      
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          const offset = 140; // Altura del header + submenu
          if (rect.top <= offset && rect.bottom >= offset) {
            setActiveSection(section);
            activeFound = true;
            break;
          }
        }
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    // Initial check
    handleScroll();
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Scroll to section function
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 140;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="ACADEMIA OPUS - Aprendizaje y Videos | Ecosoft"
        description="Aprende a utilizar OPUS con nuestra colección de videos tutoriales, webinars y cursos en línea para todos los módulos."
        name="AcademiaOpus"
        type="website"
      />
      
      {/* Hero Section */}
      <section id="hero" className="relative h-[450px] bg-[#003171]">
        <div 
          className="absolute inset-0 bg-cover bg-center" 
          style={{ 
            backgroundImage: "url('/images/academia opus.jpg')",
            backgroundPosition: "center center",
            backgroundSize: "cover"
          }}
        ></div>
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="container mx-auto px-4 h-full flex items-center pt-14 relative z-10">
          <div className="max-w-2xl text-white">
            <h1 className="text-5xl font-bold mb-4">ACADEMIA OPUS</h1>
            <p className="text-xl mb-8">
              Aprende de la mano de los expertos a través de nuestros videos tutoriales, webinars y cursos en línea.
            </p>
            <div className="flex flex-wrap gap-4">
              <a 
                href="https://www.youtube.com/@OPUSInfo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-md inline-block transition-colors"
              >
                <FaYoutube className="mr-2 text-xl" />
                Ir al Canal de YouTube
              </a>
              <a 
                href="#upcoming" 
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('upcoming');
                }}
                className="flex items-center bg-white hover:bg-gray-100 text-[#003171] px-6 py-3 rounded-md inline-block transition-colors"
              >
                <FaCalendarAlt className="mr-2 text-xl" />
                Próximas sesiones
              </a>
            </div>
          </div>
        </div>
      </section>
      
      {/* Navigation container with fixed height to prevent content jumps */}
      <div className="sticky top-[64px] z-30 bg-white shadow-md border-b border-gray-200">
        <div className="container mx-auto px-4 max-w-7xl">
          <div className="flex overflow-x-auto py-4">
            <div className="flex-grow flex space-x-4">
              <button 
                onClick={() => scrollToSection('overview')}
                className={`px-4 py-2 whitespace-nowrap font-medium ${
                  activeSection === 'overview' 
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                Resumen
              </button>
              <button 
                onClick={() => scrollToSection('presupuesto')}
                className={`px-4 py-2 whitespace-nowrap font-medium ${
                  ['presupuesto', 'planeacion', 'compras', 'dependencias', 'bim'].includes(activeSection)
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                Módulos de OPUS
              </button>
              <button 
                onClick={() => scrollToSection('erp')}
                className={`px-4 py-2 whitespace-nowrap font-medium ${
                  activeSection === 'erp' 
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                OPUS ERP
              </button>
              <button 
                onClick={() => scrollToSection('tecnicos')}
                className={`px-4 py-2 whitespace-nowrap font-medium ${
                  activeSection === 'tecnicos' 
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                Aspectos Técnicos
              </button>
              <button 
                onClick={() => scrollToSection('upcoming')}
                className={`px-4 py-2 whitespace-nowrap font-medium ${
                  activeSection === 'upcoming' 
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                Próximos Eventos
              </button>
            </div>
            <div className="flex items-center ml-4">
              <FaPlay className="text-[#0066CC] text-xl" />
            </div>
          </div>
        </div>
      </div>
      
      {/* Overview Section */}
      <section id="overview" className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">ACADEMIA OPUS</h2>
            <p className="text-gray-600">
              Accede a nuestra colección de videos tutoriales para todos los módulos de OPUS. Aprende a utilizar al máximo nuestras herramientas con instrucciones paso a paso de nuestros expertos.
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-6 mb-12">
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100">
              <h3 className="text-lg font-bold mb-3 flex items-center">
                <FaYoutube className="text-red-600 mr-3" />
                Canal de YouTube
              </h3>
              <p className="text-gray-600 mb-4">
                Visita nuestro canal oficial de YouTube para acceder a todos nuestros videos tutoriales, webinars y demostraciones de producto.
              </p>
              <a 
                href="https://www.youtube.com/@OPUSInfo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#0066CC] font-medium hover:underline flex items-center"
              >
                Ver Canal <FaArrowRight className="ml-2" />
              </a>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100">
              <h3 className="text-lg font-bold mb-3 flex items-center">
                <FaCalendarAlt className="text-[#0066CC] mr-3" />
                Webinars en Vivo
              </h3>
              <p className="text-gray-600 mb-4">
                Participa en nuestros webinars semanales donde podrás aprender y hacer preguntas a nuestros especialistas en tiempo real.
              </p>
              <a 
                href="#upcoming" 
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('upcoming');
                }}
                className="text-[#0066CC] font-medium hover:underline flex items-center"
              >
                Ver Calendario <FaArrowRight className="ml-2" />
              </a>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100">
              <h3 className="text-lg font-bold mb-3 flex items-center">
                <FaCheckCircle className="text-green-600 mr-3" />
                Certificaciones
              </h3>
              <p className="text-gray-600 mb-4">
                Obtén certificaciones oficiales en los diferentes módulos de OPUS para validar tus conocimientos y mejorar tu perfil profesional.
              </p>
              <ScrollToTopLink
                to="/certificaciones"
                className="text-[#0066CC] font-medium hover:underline flex items-center"
              >
                Ver Certificaciones <FaArrowRight className="ml-2" />
              </ScrollToTopLink>
            </div>
          </div>
        </div>
      </section>

      {/* Video Modules Sections */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-12 text-center">Módulos de OPUS</h2>
          
          {/* M1 Module - Single row */}
          <div className="max-w-6xl mx-auto mb-10">
            {videoModules.slice(0, 1).map((module, index) => (
              <div 
                id={module.id} 
                key={module.id} 
                className="bg-white rounded-lg shadow-lg overflow-hidden"
              >
                <div className="p-6">
                  <h2 className="text-2xl font-bold mb-6 text-[#003171] border-b border-gray-200 pb-3">{module.title}</h2>
                  
                  <div className="grid md:grid-cols-2 gap-6">
                    {module.videos.slice(0, 2).map(video => (
                      <div key={video.id} className="bg-white border border-gray-100 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all">
                        <div className="flex flex-col md:flex-row">
                          <div className="relative md:w-2/5">
                            <a 
                              href={`https://www.youtube.com/watch?v=${video.id}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="block h-full"
                            >
                              <img 
                                src={`https://img.youtube.com/vi/${video.id}/maxresdefault.jpg`}
                                alt={video.title}
                                className="w-full h-36 md:h-full object-cover"
                                onError={(e) => {
                                  e.target.src = `https://img.youtube.com/vi/${video.id}/hqdefault.jpg`;
                                }}
                              />
                              <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
                                <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
                                  <FaPlay className="text-white text-lg ml-1" />
                                </div>
                              </div>
                              <div className="absolute bottom-2 right-2 bg-black bg-opacity-70 text-white px-2 py-1 text-xs rounded">
                                {video.duration}
                              </div>
                            </a>
                          </div>
                          <div className="p-4 md:w-3/5 flex flex-col justify-between">
                            <div>
                              <h3 className="font-semibold text-base mb-2">{video.title}</h3>
                              <p className="text-sm text-gray-500 mb-2">
                                Video tutorial sobre el módulo de presupuesto programable
                              </p>
                            </div>
                            <div className="flex justify-between items-center text-xs mt-2">
                              <span className="text-gray-600 flex items-center">
                                <FaCalendarAlt className="mr-1" /> {video.date}
                              </span>
                              <a 
                                href={`https://www.youtube.com/watch?v=${video.id}`} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="text-[#0066CC] hover:text-[#004a99] font-medium flex items-center"
                              >
                                Ver Video <FaArrowRight className="ml-1" />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  
                  <div className="text-center mt-8">
                    <a 
                      href={module.playlistUrl} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="inline-block px-6 py-3 bg-[#0066CC] hover:bg-[#004a99] text-white font-medium rounded-md transition-colors"
                    >
                      Ver más videos de {module.title.split(' ')[1]}
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          {/* M2 and M3 Modules - Side by side */}
          <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto mb-10">
            {videoModules.slice(1, 3).map((module, index) => (
              <div 
                id={module.id} 
                key={module.id} 
                className="bg-white rounded-lg shadow-lg overflow-hidden"
              >
                <div className="p-5">
                  <h2 className="text-xl font-bold mb-4 text-[#003171] border-b border-gray-200 pb-3">{module.title}</h2>
                  
                  <div className="space-y-4">
                    {module.videos.slice(0, 2).map(video => (
                      <div key={video.id} className="bg-white border border-gray-100 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all">
                        <div className="flex flex-col md:flex-row">
                          <div className="relative md:w-1/3">
                            <a 
                              href={`https://www.youtube.com/watch?v=${video.id}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="block h-full"
                            >
                              <img 
                                src={`https://img.youtube.com/vi/${video.id}/maxresdefault.jpg`}
                                alt={video.title}
                                className="w-full h-24 md:h-full object-cover"
                                onError={(e) => {
                                  e.target.src = `https://img.youtube.com/vi/${video.id}/hqdefault.jpg`;
                                }}
                              />
                              <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
                                <div className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center">
                                  <FaPlay className="text-white text-sm ml-0.5" />
                                </div>
                              </div>
                              <div className="absolute bottom-1 right-1 bg-black bg-opacity-70 text-white px-1.5 py-0.5 text-xs rounded">
                                {video.duration}
                              </div>
                            </a>
                          </div>
                          <div className="p-3 md:w-2/3">
                            <h3 className="font-semibold text-sm mb-1 line-clamp-2">{video.title}</h3>
                            <div className="flex justify-between items-center text-xs text-gray-500 mt-2">
                              <span className="flex items-center">
                                <FaCalendarAlt className="mr-1" /> {video.date}
                              </span>
                              <a 
                                href={`https://www.youtube.com/watch?v=${video.id}`} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="text-[#0066CC] hover:text-[#004a99] font-medium"
                              >
                                Ver Video
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  
                  <div className="text-center mt-6">
                    <a 
                      href={module.playlistUrl} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="inline-block px-4 py-2 border border-[#0066CC] text-[#0066CC] hover:bg-[#0066CC] hover:text-white rounded-md transition-colors text-sm"
                    >
                      Ver más videos
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          {/* M4 and M5 Modules - Side by side */}
          <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
            {videoModules.slice(3, 5).map((module, index) => (
              <div 
                id={module.id} 
                key={module.id} 
                className="bg-white rounded-lg shadow-lg overflow-hidden"
              >
                <div className="p-5">
                  <h2 className="text-xl font-bold mb-4 text-[#003171] border-b border-gray-200 pb-3">{module.title}</h2>
                  
                  <div className="space-y-4">
                    {module.videos.slice(0, 2).map(video => (
                      <div key={video.id} className="bg-white border border-gray-100 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all">
                        <div className="flex flex-col md:flex-row">
                          <div className="relative md:w-1/3">
                            <a 
                              href={`https://www.youtube.com/watch?v=${video.id}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="block h-full"
                            >
                              <img 
                                src={`https://img.youtube.com/vi/${video.id}/maxresdefault.jpg`}
                                alt={video.title}
                                className="w-full h-24 md:h-full object-cover"
                                onError={(e) => {
                                  e.target.src = `https://img.youtube.com/vi/${video.id}/hqdefault.jpg`;
                                }}
                              />
                              <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
                                <div className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center">
                                  <FaPlay className="text-white text-sm ml-0.5" />
                                </div>
                              </div>
                              <div className="absolute bottom-1 right-1 bg-black bg-opacity-70 text-white px-1.5 py-0.5 text-xs rounded">
                                {video.duration}
                              </div>
                            </a>
                          </div>
                          <div className="p-3 md:w-2/3">
                            <h3 className="font-semibold text-sm mb-1 line-clamp-2">{video.title}</h3>
                            <div className="flex justify-between items-center text-xs text-gray-500 mt-2">
                              <span className="flex items-center">
                                <FaCalendarAlt className="mr-1" /> {video.date}
                              </span>
                              <a 
                                href={`https://www.youtube.com/watch?v=${video.id}`} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="text-[#0066CC] hover:text-[#004a99] font-medium"
                              >
                                Ver Video
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  
                  <div className="text-center mt-6">
                    <a 
                      href={module.playlistUrl} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="inline-block px-4 py-2 border border-[#0066CC] text-[#0066CC] hover:bg-[#0066CC] hover:text-white rounded-md transition-colors text-sm"
                    >
                      Ver más videos
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      {/* OPUS ERP Section */}
      <section id="erp" className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-12 text-center">OPUS ERP / ODOO</h2>
          <div className="max-w-6xl mx-auto">
            {videoModules.slice(5, 6).map((module, index) => (
              <div 
                key={module.id} 
                className="bg-white rounded-lg shadow-lg overflow-hidden mb-6"
              >
                <div className="p-6">
                  <h2 className="text-2xl font-bold mb-6 text-[#003171] border-b border-gray-200 pb-3">{module.title}</h2>
                  
                  <div className="grid md:grid-cols-2 gap-6">
                    {module.videos.slice(0, 2).map(video => (
                      <div key={video.id} className="bg-white border border-gray-100 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all">
                        <div className="flex flex-col md:flex-row">
                          <div className="relative md:w-2/5">
                            <a 
                              href={`https://www.youtube.com/watch?v=${video.id}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="block h-full"
                            >
                              <img 
                                src={`https://img.youtube.com/vi/${video.id}/maxresdefault.jpg`}
                                alt={video.title}
                                className="w-full h-32 md:h-full object-cover"
                                onError={(e) => {
                                  e.target.src = `https://img.youtube.com/vi/${video.id}/hqdefault.jpg`;
                                }}
                              />
                              <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
                                <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
                                  <FaPlay className="text-white text-lg ml-1" />
                                </div>
                              </div>
                              <div className="absolute bottom-2 right-2 bg-black bg-opacity-70 text-white px-2 py-1 text-xs rounded">
                                {video.duration}
                              </div>
                            </a>
                          </div>
                          <div className="p-4 md:w-3/5 flex flex-col justify-between">
                            <div>
                              <h3 className="font-semibold text-base mb-2">{video.title}</h3>
                              <p className="text-sm text-gray-500 mb-2">
                                Video tutorial sobre OPUS ERP basado en ODOO
                              </p>
                            </div>
                            <div className="flex justify-between items-center text-xs mt-2">
                              <span className="text-gray-600 flex items-center">
                                <FaCalendarAlt className="mr-1" /> {video.date}
                              </span>
                              <a 
                                href={`https://www.youtube.com/watch?v=${video.id}`} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="text-[#0066CC] hover:text-[#004a99] font-medium flex items-center"
                              >
                                Ver Video <FaArrowRight className="ml-1" />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  
                  <div className="text-center mt-8">
                    <a 
                      href={module.playlistUrl} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="inline-block px-6 py-3 bg-[#0066CC] hover:bg-[#004a99] text-white font-medium rounded-md transition-colors"
                    >
                      Ver más videos de OPUS ERP
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      {/* Aspectos Técnicos Section */}
      <section id="tecnicos" className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-12 text-center">OPUS ASPECTOS TÉCNICOS</h2>
          <div className="max-w-6xl mx-auto">
            {videoModules.slice(6, 7).map((module, index) => (
              <div 
                key={module.id} 
                className="bg-white rounded-lg shadow-lg overflow-hidden mb-6"
              >
                <div className="p-6">
                  <h2 className="text-2xl font-bold mb-6 text-[#003171] border-b border-gray-200 pb-3">{module.title}</h2>
                  
                  <div className="grid md:grid-cols-2 gap-6">
                    {module.videos.slice(0, 2).map(video => (
                      <div key={video.id} className="bg-white border border-gray-100 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all">
                        <div className="flex flex-col md:flex-row">
                          <div className="relative md:w-2/5">
                            <a 
                              href={`https://www.youtube.com/watch?v=${video.id}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="block h-full"
                            >
                              <img 
                                src={`https://img.youtube.com/vi/${video.id}/maxresdefault.jpg`}
                                alt={video.title}
                                className="w-full h-32 md:h-full object-cover"
                                onError={(e) => {
                                  e.target.src = `https://img.youtube.com/vi/${video.id}/hqdefault.jpg`;
                                }}
                              />
                              <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
                                <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
                                  <FaPlay className="text-white text-lg ml-1" />
                                </div>
                              </div>
                              <div className="absolute bottom-2 right-2 bg-black bg-opacity-70 text-white px-2 py-1 text-xs rounded">
                                {video.duration}
                              </div>
                            </a>
                          </div>
                          <div className="p-4 md:w-3/5 flex flex-col justify-between">
                            <div>
                              <h3 className="font-semibold text-base mb-2">{video.title}</h3>
                              <p className="text-sm text-gray-500 mb-2">
                                Video tutorial sobre aspectos técnicos de OPUS
                              </p>
                            </div>
                            <div className="flex justify-between items-center text-xs mt-2">
                              <span className="text-gray-600 flex items-center">
                                <FaCalendarAlt className="mr-1" /> {video.date}
                              </span>
                              <a 
                                href={`https://www.youtube.com/watch?v=${video.id}`} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="text-[#0066CC] hover:text-[#004a99] font-medium flex items-center"
                              >
                                Ver Video <FaArrowRight className="ml-1" />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  
                  <div className="text-center mt-8">
                    <a 
                      href={module.playlistUrl} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="inline-block px-6 py-3 bg-[#0066CC] hover:bg-[#004a99] text-white font-medium rounded-md transition-colors"
                    >
                      Ver más videos técnicos
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      {/* Upcoming Webinars Section */}
      <section id="upcoming" className="py-16 bg-[#F8FAFC]">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-8 text-center">Próximas sesiones ACADEMIA OPUS</h2>
          <p className="text-center text-gray-600 mb-10 max-w-3xl mx-auto">
            Consulta nuestros próximos eventos en vivo y aprende directamente de nuestros expertos sobre las novedades de OPUS25. Participa y resuelve tus dudas en tiempo real.
          </p>
          
          <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {upcomingWebinars.map((webinar, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-md border border-gray-100">
                <h3 className="text-xl font-bold mb-3">{webinar.title}</h3>
                <div className="mb-4">
                  <div className="flex items-center text-gray-600 mb-2">
                    <FaCalendarAlt className="mr-2 text-[#0066CC]" />
                    <span>{webinar.date}</span>
                  </div>
                  <div className="flex items-center text-gray-600">
                    <svg className="w-4 h-4 mr-2 text-[#0066CC]" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                    </svg>
                    <span>{webinar.time}</span>
                  </div>
                </div>
                <p className="text-gray-600 mb-4">
                  Presentado por: <span className="font-medium">{webinar.presenter}</span>
                </p>
                <a 
                  href={webinar.registrationLink} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="block w-full py-2 bg-[#0066CC] hover:bg-[#0055B8] text-white text-center rounded-md transition-colors"
                >
                  Ver eventos en Facebook
                </a>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-10">
            <a 
              href="https://www.facebook.com/ECOSOFTOPUS/events" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-block px-6 py-2 border border-[#0066CC] text-[#0066CC] hover:bg-[#0066CC] hover:text-white rounded-md transition-colors"
            >
              Ver todos los eventos
            </a>
          </div>
        </div>
      </section>
      
      {/* CTA Section */}
      <section className="py-16 bg-[#1A2B39] text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6">¿Listo para llevar tus conocimientos al siguiente nivel?</h2>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Explora nuestras opciones de capacitación y certificación para convertirte en un experto en OPUS.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <ScrollToTopLink 
              to="/contacto" 
              className="px-8 py-3 bg-[#0066CC] hover:bg-[#0088FF] text-white font-medium rounded-md transition-colors"
            >
              Contactar
            </ScrollToTopLink>
            <ScrollToTopLink 
              to="/certificaciones" 
              className="px-8 py-3 border border-white hover:bg-white hover:text-[#1A2B39] text-white font-medium rounded-md transition-colors"
            >
              Certificaciones
            </ScrollToTopLink>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AcademiaOpus; 